// pages/UpdateSectorPage.tsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { alertSuccess, alertServerError, alertError } from "../../../helpers/alertError";
import PageLayout from "../../../layouts/PageLayout";
import PageContainer from "../../../components/ui/PageContainer";
import { sectorService, uploadService } from "@cabukaka/services";
import SectorForm from "../../../components/features/sectors/SectorForm";
import { useSector, useToken } from "@cabukaka/hooks";
import useCustomParams from "../../../hooks/params/useCustomParams";

export default function UpdateSectorPage() {
  const { id } = useCustomParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { token } = useToken();
  const { sector: initialData } = useSector({ id: id! })



  const generateSlug = (name: string) => {
    return name
      .toLowerCase()
      .trim()
      .replace(/[éèêë]/g, 'e')
      .replace(/[àâä]/g, 'a')
      .replace(/[îï]/g, 'i')
      .replace(/[ôö]/g, 'o')
      .replace(/[ùûü]/g, 'u')
      .replace(/[ç]/g, 'c')
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '')
      .replace(/-+/g, '-')
      .replace(/^-+/, '')
      .replace(/-+$/, '');
  };

  const handleSubmit = async (data: { name: string; logoFile?: File; existingLogo?: string , order?: number }) => {
    if (!id) {
      alertError("Une erreur s'est produite. Veillez réessayer ")

      return
    };
    if (!token) {

      alertError("Veillez vous connecter ")
      return
    }

    setIsLoading(true);
    try {
      let logoUrl = data.existingLogo || '';

      if (data.logoFile) {
        logoUrl = await uploadService.upload(data.logoFile, token!);
      }

      const slug = generateSlug(data.name);

      await sectorService.baseService.update(id, {
        name: data.name,
        slug,
        logo: logoUrl,
        order: data.order
      }, token);

      alertSuccess("Secteur modifié avec succès");
      navigate(-1);
    } catch (error: any) {
      alertServerError(error);
    } finally {
      setIsLoading(false);
    }
  };

  if (!initialData) {
    return (
      <PageLayout title="Modifier le secteur">
        <div className="flex justify-center py-20">Chargement...</div>
      </PageLayout>
    );
  }

  return (
    <PageLayout title="Modifier le secteur">
      <PageContainer>
        <SectorForm
          initialData={initialData}
          onSubmit={handleSubmit}
          isSubmitting={isLoading}
        />
      </PageContainer>
    </PageLayout>
  );
}